import _ from 'lodash';

const getFullName = (firstName, lastName) => {
  return _.join([firstName, lastName], ' ').trim();
};

const getIntiial = (firstName, lastName) => {
  let firstNameIntiail = null;
  if (firstName) {
    firstNameIntiail = firstName.charAt(0);
  }
  let lastNameIntiail = null;
  if (lastName) {
    lastNameIntiail = lastName.charAt(0);
  }

  const initial = _.join([firstNameIntiail, lastNameIntiail], '');

  return initial.toUpperCase();
};

const getFullUserName = (firstName, lastName, email) => {
  const displayName = getFullName(firstName, lastName);
  return `${displayName} (${email})`;
};

export default {getFullName, getIntiial, getFullUserName};
